// extracted by mini-css-extract-plugin
module.exports = {"card":"RelatedPosts_card__C_rWb","container":"RelatedPosts_container__uRWkw","list":"RelatedPosts_list__21Q-s","item":"RelatedPosts_item__3m4p-","info":"RelatedPosts_info__1UrOW"};